module.exports = __webpack_public_path__ + "img/bus_night_up_selected.968e57e2.svg";